/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Menu from "@mui/material/Menu";
// import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";

// Soft UI Dashboard PRO React example components
import DefaultNavbarLink from "examples/Navbars/DefaultNavbar/DefaultNavbarLink";
import Icon from "@mui/material/Icon";
import Badge from "@mui/material/Badge";
import Tooltip from "@mui/material/Tooltip";

import { StoreContext } from "context/store";
import CounterContext from "context/counter";
import { AccountContext } from "context/account";
import MyProjectsContext from "context/my-projects";

import MenuPopper1 from "examples/Navbars/DefaultNavbar/Menus/MenuPopper1";
const REACT_APP_DEV_MENU = process.env.REACT_APP_DEV_MENU;

function DefaultNavbarMobile({ routes, open, close }) {
  const { width } = open && open.getBoundingClientRect();
  const [openCollapse, setOpenCollapse] = useState(false);

  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const counter = useContext(CounterContext);
  const { stagesProjects, prospects } = useContext(MyProjectsContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [openAccountMenu, setOpenAccountMenu] = useState(false);

  const account = useContext(AccountContext);
  const { store } = useContext(StoreContext);
  const { getNewMessageCount, count, ncount } = counter;

  const handleSepOpenCollapse = (name) => {
    console.log(openCollapse, name);
    return openCollapse === name ? setOpenCollapse(false) : setOpenCollapse(name);
  };

  const renderRoutes = routes.map((item, index) => {
    let name = item.name;
    if (item.countKey && counter[item.countKey]) {
      item["icon"] = (
        <Badge color="error" variant="dot" invisible={counter[item.countKey] <= 0}>
          {item.icon}
        </Badge>
      );
    }
    if (item.projectCount) {
      if (item.projectCount == "prospects") {
        name = item["name"] + `(${prospects.length})`;
      } else {
        if (stagesProjects[item.projectCount]) {
          name = item["name"] + `(${stagesProjects[item.projectCount].length})`;
        }
      }
    }

    if (item.hint) {
      name = (
        <Tooltip content={item.hint}>
          <SuiTypography>{name}</SuiTypography>
        </Tooltip>
      );
    }

    let returnValue;
    if (REACT_APP_DEV_MENU != "true") {
      //production env
      if (item.dev_menu) {
        //hide development menu
        return;
      }
    }

    let is_hidden = item.hidden || false;
    if (item?.visible_users && item?.visible_users.includes(account.id)) {
      is_hidden = false;
    }

    if (item.type === "collapse" && !is_hidden && item.name) {
      if (item.noCollapse && item.route) {
        returnValue = (
          <div key={index}>
            <Link to={item.route} key={item.key}>
              <DefaultNavbarLink
                name={name}
                collapse={item.collapse}
                collapseStatus={openCollapse === item.name}
                onClick={() => handleSepOpenCollapse(item.name)}
                mobileMenu
              />
            </Link>
          </div>
        );
      } else {
        returnValue = (
          <div key={index}>
            <DefaultNavbarLink
              name={name}
              collapse={item.collapse}
              collapseStatus={openCollapse === item.name}
              onClick={() => handleSepOpenCollapse(item.name)}
              mobileMenu
            >
              {openCollapse === item.name ? (
                <MenuPopper1
                  routes={item.collapse}
                  open={open}
                  close={close}
                  key={item.name}
                  mobileMenu
                />
              ) : null}
            </DefaultNavbarLink>
          </div>
        );
      }
    }

    return returnValue;
  });

  return (
    <Menu
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      anchorEl={open}
      open={Boolean(open)}
      onClose={close}
      MenuListProps={{ style: { width: `calc(${width}px - 4rem)` } }}
    >
      <SuiBox px={0.5}>{renderRoutes}</SuiBox>
    </Menu>
  );
}

// Typechecking props for the DefaultNavbarMenu
DefaultNavbarMobile.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  close: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
};

export default DefaultNavbarMobile;
